const urlList = {
    GET_ALL_BLOGS: '/api/v1/oodles/getAllBlogs',
    GET_ALL_TAGS: '/api/v1/oodles/getAllTags',
    GET_ALL_RELATED_TAGS: '/api/v1/oodles/getAllRelatedTags',
    GET_ALL_RELATED_BLOGS: '/api/v1/oodles/getAllRelatedBlogs',
    GET_SINGLE_BLOG: '/api/v1/oodles/getSingleBlog',
    GET_RELATED_BLOG: '/api/v1/oodles/getAllRecommendedBlogs',
    GET_GLOBAL_SEARCH_BLOG: '/api/v1/oodles/getBlogByGlobalSearch',
    GET_DEPARTMENT: '/api/v1/getAllDepartmentWithSkill',
    GET_ALL_CATEGORY: '/api/v1/getCategory',
}

export default urlList;